import * as z from "zod";

export const userChangePasswordSchema = z.object({
  email: z.string().email({ message: "Invalid email address" }),
  currentPassword: z.string().min(1, "Current password is required"),
  newPassword: z.string().min(6, "New password must be at least 6 characters"),
  confirmPassword: z.string(),
}).refine((data) => data.newPassword === data.confirmPassword, {
  message: "Passwords do not match",
  path: ["confirmPassword"],
});

export type UserChangePasswordInput = z.infer<typeof userChangePasswordSchema>;
